/** The app routes */
export enum Routes {
  // Static screens
  TOKEN_FROZEN = '/tokenFrozen',
  TOKEN_ACTIVE = '/tokenActive',
  TOKEN_REJECTED = '/tokenRejected',
  TOKEN_REVOKED = '/tokenRevoked',
  TOKEN_IN_REVIEW = '/tokenInReview',
  TOKEN_REFRESH_IN_REVIEW = '/tokenRefreshInReview',
  TOKEN_IN_PARTNER_REVIEW = '/tokenInPartnerReview',
  TOKEN_MANUAL_REVIEW = '/tokenManualReview',
  FAILED_IP_CHECK = '/failedIpCheck',
  FAILED_VPN_CHECK = '/failedVpnCheck',
  PROOF_OF_WALLET_OWNERSHIP = '/proofOfWalletOwnership',
  CONFIRM_WALLET_TRANSACTION = '/confirmTransaction',
  GENERIC_STATUS_SCREEN = '/status',
  AWAITING_TRANSACTION_CONFIRMATION = '/awaitingTransactionConfirmation',
  CHAIN_ERROR = '/chainError',
  CREDENTIAL_EXPIRED = '/credentialExpired',
  UNIQUENESS_ERROR = '/uniquenessError',
  SIGN_TRANSACTION = '/signTransaction',
  THEME_DEMO = '/themeDemo',
  UNSUPPORTED_VERSION = '/unsupportedVersion',
  CIVIC_SIGNS_NOT_SUPPORTED = '/civicSignsNotSupported',
  INVALID_CONFIGURATION = '/invalidConfiguration',
  SHARE_PERSONAL_DETAILS = '/sharePersonalDetails',
  CAPTURE_PERSONAL_DETAILS = '/capturePersonalDetails',

  // Face flow
  FACE_AUTH = '/faceAuth',
  FACE_UNIQUENESS = '/faceUniqueness',
  FACE_SEARCH = '/faceSearch',
  // Explainer screens
  EXPLAINER = '/explainer',
  EXPLAINER_CAPTCHA = '/explainer/captcha',
  EXPLAINER_DOCUMENT = '/explainer/document',
  EXPLAINER_SIP = '/explainer/sip',
  EXPLAINER_UNIQUENESS = '/explainer/uniqueness',
  EXPLAINER_TEST = '/explainer/test',
  EXPLAINER_LIVENESS = '/explainer/liveness',
  EXPLAINER_AGE_CHECK_13 = '/explainer/ageCheck13',
  EXPLAINER_FACE_AGE_CHECK_13 = '/explainer/faceAgeCheck13',
  // Document Flow
  DOCUMENT_SELFIE = '/document/selfie',
  DOCUMENT_CAPTURE = '/document/capture',
  // Validation flow
  LOGIN = '/login',
  CHOOSE_WEB_OR_MOBILE = '/chooseWebOrMobile',
  VALIDATION_NEXT_STEP = '/validation/next',
  VALIDATION_IN_PROGRESS = '/inProgress',
  VALIDATION_IN_REVIEW = '/inReview',
  VALIDATION_REJECTED = '/rejected',
  VALIDATION_ERROR = '/validation/error',
  VALIDATION_FINALIZING = '/validation/finalizing',
  VALIDATION_STATUS = '/validation/status',
  CONTINUE = '/continue',
  CONTINUE_WITH_LINK = '/continueLink',
  LINK_DEVICES = '/link',
  DEVICE_LINKED = '/deviceLinked',
  UPLOAD_COMPLETE = '/uploadComplete',
  // DoB flow
  DOB_CAPTURE = '/dateOfBirth',
  // Email flow
  EMAIL_CAPTURE = '/email/capture',
  EMAIL_VERIFY = '/email/verify',
  // SIP flow
  QR_CODE = '/qrcode',
  CANCEL = '/cancel',
  ERROR = '/error',
  // Generic
  DECLARATIONS = '/declarations',
  WALLET_TOKEN_SUCCESS = '/walletTokenSuccess',
  // Recaptcha flow
  CAPTCHA = '/captcha',
  // Refresh without any flow
  NO_FLOW = '/noFlow',
  SUPPORT = '/support',
  AUTHENTICATION_ONLY = '/authenticationOnly',
  // Revocation
  REVOCATION = '/revocation',
  REVOCATION_QR_CODE = '/revocationQrCode',
  REVOCATION_PASSES_LIST = '/revocationList',
  REVOCATION_SUCCESS = '/revocationSuccess',
  REVOCATION_IN_REVIEW = '/revocationInReview',
  // Civic Demo flow
  CIVIC_DEMO = '/civicDemo',
  START_PRE_APPROVED_TRANSACTION = '/startPreApprovedTransaction',
  STORE_CREDENTIALS = '/storeCredentials',
  CHECK_FOR_EXISTING_CREDENTIALS = '/checkForExistingCredentials',
  CHOOSE_CREDENTIALS = '/chooseCredentials',
  FUNDS_CHECK = '/fundsCheck',
}

export interface RouteState {
  from: string;
}

export default { Routes };
